@let apiResponse = data.value(); @if (apiResponse) {
<p-table
  [value]="apiResponse.data"
  stripedRows
  [loading]="data.isLoading()"
  [scrollable]="true"
  scrollHeight="flex"
  class="p-datatable-sm lp-table"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Tidspunkt</th>
      <th>Bruger</th>
      <th>Kommentar</th>
      <th>Ændringer</th>
    </tr>
  </ng-template>
  <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-hist>
    <tr>
      <td class="numbers">{{ hist.tidspunkt | date : "dd-MM-yyyy HH:mm" }}</td>
      <td>{{ hist.brugerNavn }}</td>
      <td>{{ hist.kommentar }}</td>
      <td>
        <pre>{{ hist.systemKommentar }}</pre>
      </td>
    </tr>
  </ng-template>
</p-table>
}
